// extracted by mini-css-extract-plugin
module.exports = {"form":"InsertContractModal_style_form__1v0j2"};